// @flow
import routes from '../routes';

export function routePermissions(routeType: string): string[] {
  if (!routeType) {
    return [];
  }

  const route = routes[routeType];
  const { permissions } = route;

  if (!permissions) {
    return [];
  }

  if (typeof permissions === 'string') {
    return [permissions];
  }

  return permissions;
}

export default routePermissions;



// WEBPACK FOOTER //
// ./src/modules/router/helpers/routePermissions.js